<template>
	<div>
		<CRow v-if="showConsult" class="justify-content-center">
			<CCol sm="12">
				<CCard>
					<CCardHeader style="background: #97ca3d; color: black;">
						<h3>
							Solicitudes Masivas por Procesar
						</h3>
					</CCardHeader>
					<CCardBody>
						<CRow>
							<CCol>
								<span class="float-left">
									<p>
										Para ver las solicitudes por procesar de
										un envío asignado debes hacer clic en el
										ícono <b><i class="fas fa-eye"></i></b>
									</p>
								</span>
							</CCol>
						</CRow>
						<!-- filtro de la tabla -->
						<CRow>
							<CCol sm="4">
								<CInput
									v-model="filter"
									placeholder="Búscar"
									label="Filtrar"
								></CInput>
							</CCol>
							<CCol sm="4">
								<div role="group" class="form-group">
									<label for="urb"
										>Registros por Página</label
									>
									<multiselect
										v-model="perPage"
										:options="recordsPergPage"
										:searchable="false"
										:close-on-select="true"
										:show-labels="false"
										placeholder="Seleccione"
									>
									</multiselect>
								</div>
							</CCol>
						</CRow>
						<!-- tabla de los envios -->
						<CRow>
							<CCol sm="12">
								<p style="margin-bottom: 30px;">
									<span class="float-right"
										>Cantidad de Envíos:
										<CBadge shape="pill" color="info">
											{{ totalRows }}</CBadge
										>
									</span>
								</p>
								<b-table
									:fixed="true"
									v-if="showTable"
									@filtered="onFiltered"
									:filter="filter"
									stacked="lg"
									striped
									outlined
									hover
									bordered
									:current-page="currentPage"
									:per-page="perPage"
									:items="tableConsult"
									:fields="fieldsTableConsult"
								>
									<!-- botones de la seccion acciones -->
									<template #cell(actions)="row">
										<!-- <b-button v-if="row.item.statusId === 12" disabled title="Procesar" pill variant="primary" size="sm" class="mr-1">
                                            <i class="fas fa-tasks"></i>
                                        </b-button>
                                        <b-button v-else @click="goToProcess(row.item)" title="Procesar" pill variant="primary" size="sm" class="mr-1">
                                            <i class="fas fa-tasks"></i>
                                        </b-button> -->
										<b-button
											@click="goToProcess(row.item)"
											title="Ver Detalle"
											pill
											variant="primary"
											size="sm"
											class="mr-1"
										>
											<i class="fas fa-eye"></i>
										</b-button>
									</template>
								</b-table>
							</CCol>
						</CRow>
						<!-- paginacion de la tabla -->
						<CRow>
							<CCol sm="12">
								<b-pagination
									v-model="currentPage"
									:total-rows="totalRows"
									:per-page="perPage"
									align="right"
									first-number
									last-number
									pills
								>
									<template #prev-text
										><span class="text-primary"
											>Anterior</span
										></template
									>
									<template #next-text
										><span class="text-success"
											>Siguiente</span
										></template
									>
									<template #page="{ page, active }">
										<b v-if="active">{{ page }}</b>
										<i v-else>{{ page }}</i>
									</template>
								</b-pagination>
							</CCol>
						</CRow>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
		<CRow v-else class="justify-content-center">
			<CCol sm="12">
				<CCard>
					<CCardHeader style="background: #97ca3d; color: black;">
						<h3>
							Solicitudes Masivas por Procesar
						</h3>
					</CCardHeader>
					<CCardBody>
						<CRow>
							<CCol>
								<span class="float-left">
									<!-- <p>Para ver el progreso de los analistas asignados a una solicitud debes hacer clic
                                        en el ícono <b><i class="fas fa-eye"></i></b></p> -->
									<p>
										No tienes solicitudes masivas por
										procesar.
									</p>
								</span>
							</CCol>
						</CRow>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
	</div>
</template>
<script>
	/** Componente que muestra la tabla con los envíos masivos asignados al usuario logueado */
	import requestsForUser from '../../functions/functionRequestForUsers';
	export default {
		name: 'massiveRequestForUser',
		title: 'Solicitudes Individuales | Infoguia',
		data() {
			return {
				showConsult: true,
				fieldsTableConsult: [
					{
						key: 'categorie',
						label: 'Categoría',
					},
					{
						key: 'location',
						label: 'Localidades',
					},
					{
						key: 'createdDate',
						label: 'Fecha de Creación',
						thStyle: {
							width: '205px',
						},
					},
					{
						key: 'quatityAssigned',
						label: 'Asignadas',
						tdClass: 'content-right',
						thStyle: {
							width: '105px',
						},
					},
					{
						key: 'quantityProcess',
						label: 'Procesadas',
						tdClass: 'content-right',
						thStyle: {
							width: '110px',
						},
					},
					{
						key: 'quatityRejected',
						label: 'Rechazadas',
						tdClass: 'content-right',
						thStyle: {
							width: '115px',
						},
					},
					{
						key: 'quantityForProcess',
						label: 'Por Procesar',
						tdClass: 'content-right',
						thStyle: {
							width: '120px',
						},
					},
					{
						key: 'actions',
						label: 'Acciones',
						thStyle: {
							width: '100px',
						},
					},
				],
				tableConsult: [],
				//datos de la paginacion
				currentPage: 1,
				totalRows: 0,
				perPage: 10,
				filter: '',
				recordsPergPage: [5, 10, 15, 20],
				showTable: false,
			};
		},
		created() {
			this.loadingMassiveRequestForUser();
		},
		methods: {
			onFiltered(filteredItems) {
				// Metodo para actualizar el numero de paginas en el paginado a medida que se filtra
				this.totalRows = filteredItems.length;
				this.currentPage = 1;
			},
			loadingMassiveRequestForUser() {
				let loader = this.$loading.show();
				requestsForUser
					.getMassiveRequestsForUser()
					.then((response) => {
						if (response.length) {
							this.totalRows = response.length;
							for (
								let index = 0;
								index < response.length;
								index++
							) {
								this.tableConsult[index] = {
									categorie:
										response[index].categoria
											.nombrecategoria,
									location: 'Nacional',
									createdDate: response[index].created_at,
									quatityAssigned:
										response[index].requestsAssigned,
									quantityProcess:
										response[index].requestsUpdatedUser,
									quatityRejected:
										response[index].requestsRejected,
									quantityForProcess:
										response[index].requestsForProcess,
									statusId: response[index].status.idStatuses,
									_rowVariant: '',
									idRequest: response[index].idRequests,
								};
								if (response[index].locationSent == 'S') {
									let statesStrin = '';
									for (
										let indexStates = 0;
										indexStates <
										response[index].estados.length;
										indexStates++
									) {
										statesStrin +=
											response[index].estados[indexStates]
												.nombreestado + ', ';
										this.tableConsult[
											index
										].location = statesStrin
											.trim()
											.slice(0, -1);
									}
								} else if (
									response[index].locationSent == 'C'
								) {
									let citiesString = '';
									for (
										let indexCities = 0;
										indexCities <
										response[index].ciudades.length;
										indexCities++
									) {
										citiesString +=
											response[index].ciudades[
												indexCities
											].nombreciudad + ', ';
										this.tableConsult[
											index
										].location = citiesString
											.trim()
											.slice(0, -1);
									}
								} else if (
									response[index].locationSent == 'U'
								) {
									let urbString = '';
									for (
										let indexUrb = 0;
										indexUrb <
										response[index].urbanizations.length;
										indexUrb++
									) {
										urbString +=
											response[index].urbanizations[
												indexUrb
											].nameUrbanization + ', ';
										this.tableConsult[
											index
										].location = urbString
											.trim()
											.slice(0, -1);
									}
								}
							}
							if (this.tableConsult.length > 0) {
								this.showTable = true;
							}
						} else {
							this.showConsult = false;
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						loader.hide();
					});
			},
			goToProcess(row) {
				let idRequest = row.idRequest;
				// let stepFilled = row.progress
				this.$router.push(
					'/massiverequestforuser/detailMassiveRequestUser/' +
						idRequest
				);
			},
		},
	};
</script>
